import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { useOrg } from '../context/OrgContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isPlatform, legalName } = useOrg();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Sitemap:
            {' '}
            <Link href="/dashboard" color="primary" sx={{ mx: 0.5 }}>
              DASHBOARD
            </Link>
            {' • '}
            <Link href="/payments" color="primary" sx={{ mx: 0.5 }}>
              PAYMENTS
            </Link>
            {' • '}
            <Link href="/performance" color="primary" sx={{ mx: 0.5 }}>
              PERFORMANCE
            </Link>
            {' • '}
            <Link href="/settings" color="primary" sx={{ mx: 0.5 }}>
              SETTINGS
            </Link>
            {' • '}
            <Link href="/help" color="primary" sx={{ mx: 0.5 }}>
              HELP
            </Link>
          </Typography>
        </Box>
        
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            ©{currentYear} {isPlatform ? 'WKMC, LLC' : legalName}
            {isPlatform && (
              <>
                {' • '}
                <Link href="/privacy.html" color="primary" sx={{ mx: 0.5 }}>
                  PRIVACY
                </Link>
                {' • '}
                <Link href="/service-provider-terms" color="primary" sx={{ mx: 0.5 }}>
                  SERVICE PROVIDER TERMS
                </Link>
                {' • '}
                <Link href="/terms.html" color="primary" sx={{ mx: 0.5 }}>
                  WKMC TERMS
                </Link>
              </>
            )}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;